export default "__VITE_ASSET__BTHzT7FV__"